import { shippingAddressStyles as styles } from "@insite/content-library/Widgets/CheckoutShipping/ShippingAddress";
import {
    commonHeadingShipStyles,
    commonShipLinkStyles,
} from "@solveindustrial/WidgetExtensions/CheckoutShipping/BillingAddressExtension";
import { css } from "styled-components";

styles.headingGridItem = {
    ...styles.headingGridItem,
    css: css`
        ${styles.headingGridItem?.css}
        ${commonHeadingShipStyles}
    `,
};

styles.headingText = {
    ...styles.headingText,
    variant: "h4",
};

styles.selectSavedAddressLink = {
    ...styles.selectSavedAddressLink,

    css: css`
        ${styles.selectSavedAddressLink?.css}
        ${commonShipLinkStyles}
    `,
};
